module.exports = __webpack_public_path__ + "static/media/mom2.9058ca60.png";